import React from "react";

const TabPanel = (props) => {
    const {children, value, index, orientation} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            style={{
                overflow: 'auto',
                height: orientation === 'vertical' ? '100%' : 'calc(100% - 34px)',
                width: orientation === 'vertical' ? '100%' : 'auto'
            }}
        >
            {children}
        </div>
    )
};
export default TabPanel;